import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-barcodescsolution',
  templateUrl: './barcodescsolution.component.html',
  styleUrls: ['./barcodescsolution.component.scss']
})
export class BarcodescsolutionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
